import "./App.css";
import React, { useEffect, useState } from "react";
import Navigation from "./components/navigation";
import Homepage from "./components/homepage";
import Homepage_sliders from "./components/homepage_sliders";
import AboutUs from "./components/about_us";
import Menu from "./components/menu";
import Gallery from "./components/gallery";
import Location from "./components/location";
import Footer from "./components/footer";
import HappyHour from "./components/HappyHour";
import { useDispatch, useSelector } from "react-redux";
import { getStoreInfo, loadApi } from "./redux/api/actions";
import { Spinner } from "react-bootstrap";

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const lockhartApi = useSelector((state) => state.apiReducer);
  // console.log("TEST", lockhartApi);

  const getInfo = async () => {
    let results = await getStoreInfo().then((response) => {
      dispatch(loadApi(response.data));
      setLoading(false);
    });
  };

  useEffect(() => {
    getInfo();
  }, []);

  return loading === true ? (
    <div>
      <Spinner animation="border" role="status" variant="light" />
    </div>
  ) : (
    <>
      <div id="home" className="main">
        <Navigation {...lockhartApi.store} />
        <Homepage {...lockhartApi} />
      </div>
      <Homepage_sliders {...lockhartApi.galleryCategories[0]} />
      <div id="about" className="beertap">
        <div className="beertapShade">
          <div className="container">
            <AboutUs {...lockhartApi.store} />
          </div>
        </div>
      </div>
      <div id="service" className="cheers">
        <div className="cheersShade">
          <HappyHour />
        </div>
      </div>
      <div id="menu">
        <Menu {...lockhartApi} />
        {/* <SmallMenu {...lockhartApi} /> */}
      </div>
      <div id="gallery" className="gallery ">
        <Gallery {...lockhartApi.galleryCategories[1]} />
      </div>
      <div className="location d-none d-lg-block">
        <div className="container">
          <Location {...lockhartApi.store} />
        </div>
      </div>
      <div className="footer">
        <Footer {...lockhartApi} />
      </div>
    </>
  );
}

export default App;
